export interface QuickReply {
  id: string;
  title: string;
  category: string;
  message: string;
  changeStatusTo?: string;
}

export const QUICK_REPLIES: QuickReply[] = [
  {
    id: 'acesso-ingresso',
    title: 'Acesso ao ingresso',
    category: 'Ingressos',
    message:
      'Olá, {nome}!\n\n' +
      'Acesse o aplicativo Banco do Ingresso e faça login com seu CPF e senha.\n\n' +
      'Depois, vá até a aba “Meus ingressos”.\n' +
      'Clique em “Visualizar ingresso” (esse primeiro aparece em vermelho) e, em seguida, clique novamente em “Visualizar ingresso”.\n\n' +
      'Assim, seu ingresso será exibido com o QR Code para entrada no evento.\n\n' +
      '📶 Importante: o ingresso funciona de forma offline.\n' +
      'Ou seja, você pode abrir ele uma vez com internet (Wi-Fi ou 4G) e, depois disso, não precisa mais de conexão para acessar no local do evento.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'uso-passaporte-qr-code',
    title: 'Uso do passaporte / QR Code',
    category: 'Ingressos',
    message:
      'Olá, {nome}!\n\n' +
      'O passaporte possui um único QR Code, válido para todos os dias do evento.\n\n' +
      'Você utilizará o mesmo QR Code diariamente.\n' +
      'Na entrada, basta apresentar o código e será entregue a pulseira referente ao dia.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'informacoes-evento',
    title: 'Informações do evento',
    category: 'Evento',
    message:
      'Olá, {nome}!\n\n' +
      'As orientações específicas do evento (regras, acesso, horários, cancelamento, etc.) são definidas exclusivamente pelo produtor.\n\n' +
      'Recomendamos verificar a aba “Sobre” na página do evento.\n\n' +
      'Caso a informação não esteja disponível, orientamos entrar em contato diretamente com o Instagram oficial do evento.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'compra-ingresso',
    title: 'Compra de ingresso',
    category: 'Compra',
    message:
      'Olá, {nome}!\n\n' +
      'A compra pode ser realizada de forma rápida e segura pelo site oficial ou aplicativo do Banco do Ingresso.\n\n' +
      'Caso tenha dificuldade no site, recomendamos tentar diretamente pelo aplicativo, que pode apresentar melhor estabilidade.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'meia-entrada',
    title: 'Meia-entrada',
    category: 'Evento',
    message:
      'Olá, {nome}!\n\n' +
      'A validação do benefício de meia-entrada ocorre somente na entrada do evento, mediante apresentação do documento exigido.\n\n' +
      'Por isso, não conseguimos confirmar previamente a aprovação.\n\n' +
      'Em caso de dúvidas, orientamos contato com o produtor pelo Instagram oficial do evento.',
    changeStatusTo: 'Resolvido',
  },

  {
    id: 'transferencia-regras-gerais',
    title: 'Transferência de ingresso',
    category: 'Transferência',
    message:
      'Olá, {nome}!\n\n' +
      'A transferência segue as seguintes regras:\n' +
      '• O favorecido deve possuir conta válida e verificada\n' +
      '• Pode ser realizada até 3 horas antes do evento\n' +
      '• Cada ingresso pode ser transferido apenas uma vez\n' +
      '• Após transferido, ficará disponível somente na conta do favorecido\n\n' +
      'Passo a passo:\n' +
      '• Acesse o aplicativo com CPF e senha\n' +
      '• Vá em Ingressos\n' +
      '• Clique em Transferir ingresso\n' +
      '• Informe o CPF do favorecido\n' +
      '• Pressione “Done” no teclado\n' +
      '• Finalize a transferência',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'transferencia-prazo-encerrado',
    title: 'Transferência - prazo encerrado',
    category: 'Transferência',
    message:
      'Olá, {nome}!\n\n' +
      'Os portões abrem às 18h e a transferência é permitida até 3 horas antes do evento.\n\n' +
      'Como o prazo foi encerrado, não é mais possível transferir o ingresso.\n\n' +
      'Uma alternativa é que a pessoa utilize seu login para acessar o QR Code.\n' +
      'Após o evento, recomendamos alterar sua senha.',
    changeStatusTo: 'Resolvido',
  },

  {
    id: 'transferencia-ja-realizada',
    title: 'Transferência - já realizada',
    category: 'Transferência',
    message:
      'Olá, {nome}!\n\n' +
      'Esse ingresso já foi transferido uma vez.\n\n' +
      'Cada ingresso pode ser transferido apenas 1 vez.\n' +
      'Como ele já foi transferido para você, não é possível transferir novamente.',
    changeStatusTo: 'Resolvido',
  },

  {
    id: 'problema-transferencia',
    title: 'Problema com transferência',
    category: 'Transferência',
    message:
      'Olá, {nome}!\n\n' +
      'Para que possamos verificar a transferência, é necessário que a pessoa que realizou o envio entre em contato.\n\n' +
      'Somente com os dados do comprador conseguimos localizar a operação e analisar o ocorrido.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'cancelamento-dentro-prazo',
    title: 'Cancelamento dentro do prazo',
    category: 'Cancelamento',
    message:
      'Olá, {nome}!\n\n' +
      'O cancelamento deve ser solicitado pelo titular no aplicativo.\n\n' +
      'É permitido em até 7 dias corridos após a compra, conforme o artigo 49 do CDC, desde que o evento esteja a mais de 24 horas da realização.\n\n' +
      'Após aprovado, o reembolso será feito pela mesma forma de pagamento.\n\n' +
      'Passo a passo:\n' +
      '• Acesse com CPF e senha\n' +
      '• Vá em Ingressos\n' +
      '• Clique em Ver detalhes\n' +
      '• Selecione Cancelar pedido',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'cancelamento-fora-prazo',
    title: 'Cancelamento fora do prazo',
    category: 'Cancelamento',
    message:
      'Olá, {nome}!\n\n' +
      'O cancelamento por arrependimento deve ser solicitado em até 7 dias após a compra.\n\n' +
      'Como a solicitação foi feita após esse período, não é possível realizar o cancelamento.',
    changeStatusTo: 'Resolvido',
  },

  {
    id: 'cancelamento-evento-proximo',
    title: 'Cancelamento - evento próximo',
    category: 'Cancelamento',
    message:
      'Olá, {nome}!\n\n' +
      'Quando o evento ocorre em menos de 7 dias da compra, o cancelamento pode ser solicitado com até 48 horas de antecedência.\n\n' +
      'Após esse prazo ou no dia do evento, não é possível cancelar.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'cancelamento-dia-evento',
    title: 'Cancelamento - dia do evento',
    category: 'Cancelamento',
    message:
      'Olá, {nome}!\n\n' +
      'Não realizamos cancelamentos no dia do evento.\n\n' +
      'O prazo mínimo é de 24 horas antes da realização.',
    changeStatusTo: 'Resolvido',
  },

  {
    id: 'reembolso',
    title: 'Reembolso',
    category: 'Reembolso',
    message:
      'Olá, {nome}!\n\n' +
      'Cartão de crédito: prazo de 30 a 40 dias após confirmação, podendo cair na fatura atual ou próxima.\n\n' +
      'Pix: prazo de 20 a 30 dias, com devolução na mesma conta utilizada.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'instabilidade-sistema',
    title: 'Instabilidade no sistema',
    category: 'Pagamento',
    message:
      'Olá, {nome}!\n\n' +
      'Identificamos uma instabilidade momentânea em algumas compras.\n\n' +
      'Em alguns casos, o pagamento foi aprovado, mas o status pode demorar para atualizar.\n\n' +
      'Nossa equipe já está corrigindo e a regularização será feita em breve.\n\n' +
      'Se necessário, tente novamente dentro de alguns minutos.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'validacao-facial',
    title: 'Validação facial',
    category: 'Cadastro',
    message:
      'Olá, {nome}!\n\n' +
      'Realize a validação em um ambiente bem iluminado, sem boné, óculos ou acessórios.\n\n' +
      'Mantenha o rosto centralizado e totalmente visível.\n\n' +
      'Evite luz forte atrás da cabeça.\n\n' +
      'Caso não funcione no site, tente pelo aplicativo.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'perda-ingresso',
    title: 'Perda do ingresso',
    category: 'Ingressos',
    message:
      'Olá, {nome}!\n\n' +
      'O ingresso é de responsabilidade do comprador após a aquisição.\n\n' +
      'Apenas fotos não garantem acesso, pois a validação é feita pelo QR Code no aplicativo.\n\n' +
      'Você pode tentar apresentar, mas não podemos garantir a entrada nessas condições.',
    changeStatusTo: 'Resolvido',
  },

  {
    id: 'validacao-cartao',
    title: 'Validação de cartão',
    category: 'Pagamento',
    message:
      'Olá, {nome}!\n\n' +
      'Antes de realizar a compra no cartão, é necessário fazer a validação do seu cartão no sistema.\n\n' +
      'A validação acontece através de um valor teste que aparece na sua fatura, normalmente entre R$ 1,00 e R$ 6,00.\n\n' +
      'Assim que esse valor constar na fatura, basta informá-lo no site para concluir a validação.\n\n' +
      'Após essa etapa, sua compra poderá ser finalizada normalmente.\n\n' +
      'Esse processo é importante para garantir a segurança da transação e confirmar que o cartão pertence ao titular da compra.',
    changeStatusTo: 'Aguardando Cliente',
  },

  {
    id: 'validacao-3ds',
    title: 'Validação 3DS',
    category: 'Pagamento',
    message:
      'Olá, {nome}!\n\n' +
      'A validação 3DS é uma etapa de segurança solicitada pelo banco do seu cartão no momento da compra.\n\n' +
      'Após inserir os dados do cartão, o banco pode pedir uma confirmação adicional, que pode ser feita por código SMS, aplicativo do banco ou biometria.\n\n' +
      'Para concluir a compra, basta seguir as instruções exibidas na tela e realizar a confirmação solicitada pelo seu banco.\n\n' +
      'Essa etapa é obrigatória em algumas transações e serve para garantir mais segurança no pagamento.\n\n' +
      'Caso não conclua essa validação, a compra pode não ser aprovada.',
    changeStatusTo: 'Aguardando Cliente',
  },
];
